"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const tiff_png_1 = __importDefault(require("../../assets/tiff.png"));
const PdfViewer_1 = require("./PdfViewer");
const DocumentSkeleton_1 = require("./DocumentSkeleton");
const path_1 = __importDefault(require("path"));
const ThumbnailBody = Theme_1.styled.div `
  margin-left: 10px;
  margin-right: 10px;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  .cloverThumbnailImageOverlay {
    height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
    width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  }

  &:hover .cloverThumbnailLabel {
    font-weight: bold;
  }

  &:hover .cloverThumbnailImageOverlay {
    background-color: ${(props) => props.theme.gray};
    border-radius: 3px;
    height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
    width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  }

  &:hover .cloverThumbnailImage {
    opacity: 0.1;
  }

  &:hover .cloverThumbnailRemove {
    display: block;
    cursor: pointer;
  }

  &:hover .viewLabel {
    opacity: 1;
    color: ${(props) => props.theme.gray4};
  }

  height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
`;
const RemoveButton = Theme_1.styled.button `
  background: none;
  border: none;
  font-weight: bold;
  font-size: ${(props) => (props.size ? '10px;' : '20px;')};
  text-align: center;
  width: ${(props) => (props.size ? '20px;' : '30px;')};
  height: ${(props) => (props.size ? '20px;' : '30px;')};
  border-radius: 50%;
  position: absolute;
  right: 0;
  color: #fff;
  display: none;
  z-index: 2;

  &:hover {
    box-shadow: inset 0 0 0 2em rgba(152, 152, 152, 0.65);
    transition: 0.55s;
    display: block;
  }

  &:active {
    box-shadow: none;
    transition: 0.15s;
  }
`;
const ThumbnailImage = Theme_1.styled.img `
  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  border-radius: 3px;
  z-index: 0;
  overflow: hidden;

  .react-pdf__message--error {
    font-size: 12px;
    color: #fff;
  }
  &:hover {
    opacity: 0.4;
  }
`;
const ThumbnailLabel = Theme_1.styled.div `
  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  font-size: 13px;
  margin-top: 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  white-space: nowrap;
  color: ${(props) => props.lightBackground ? props.theme.gray2 : props.theme.white};
  &:hover {
    font-weight: bold;
  }
`;
const ViewLabel = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: ${(props) => (props.size ? '11px;' : '18px;')};
  position: absolute;
  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
`;
const ThumbnailWrapper = (props) => {
    function removeImage() {
        props.removeImage && props.removeImage(props.image.name);
    }
    function thumbnailOnLoad() {
        props.imageLoaded && props.imageLoaded(props.image);
    }
    function thumbnailOnError() {
        props.imageLoadedError && props.imageLoadedError(props.image);
    }
    function determineThumbnail() {
        if (!props.image.url) {
            return react_1.default.createElement(DocumentSkeleton_1.DocumentSkeleton, Object.assign({}, props));
        }
        else {
            const extension = path_1.default.extname(props.image.name).toLowerCase();
            if (props.image.isPdf || extension === '.pdf') {
                return (react_1.default.createElement(PdfViewer_1.PdfViewer, { imageLoadedError: thumbnailOnError, imageLoaded: thumbnailOnLoad, size: props.size, pdf: props.image }));
            }
            else if (props.image.isTiff ||
                extension === '.tiff' ||
                extension === '.tif') {
                return (react_1.default.createElement(ThumbnailImage, { className: "cloverThumbnailImage", src: tiff_png_1.default, size: props.size, onLoad: thumbnailOnLoad, onError: thumbnailOnError }));
            }
            else {
                return (react_1.default.createElement(ThumbnailImage, { className: "cloverThumbnailImage", src: props.image.url, size: props.size, onLoad: thumbnailOnLoad, onError: thumbnailOnError }));
            }
        }
    }
    return (react_1.default.createElement(ThumbnailBody, Object.assign({}, props),
        props.removeImage && (react_1.default.createElement(RemoveButton, Object.assign({ className: "cloverThumbnailRemove" }, props, { onClick: removeImage }), "\u2715")),
        react_1.default.createElement("div", { className: "cloverThumbnailImageOverlay", onClick: () => {
                window.open(props.image.url, '_blank');
            } },
            react_1.default.createElement(ViewLabel, Object.assign({}, props, { className: "viewLabel" }), "VIEW"),
            determineThumbnail()),
        !props.hideLabel && (react_1.default.createElement(ThumbnailLabel, Object.assign({ className: "cloverThumbnailLabel" }, props), props.image.name))));
};
function areEqual(prevProps, nextProps) {
    return prevProps.image.url === nextProps.image.url;
}
exports.Thumbnail = react_1.default.memo(ThumbnailWrapper, areEqual);
//# sourceMappingURL=Thumbnail.js.map